import { apm } from '@elastic/apm-rum';
import { Button } from '@mui/material';
import React from 'react';
import { ColorPalette } from '../components/config/color-palette';
import { getUserManager } from './auth-initialize';

export function LogoutButton() {
  return (
    <Button
      variant="outlined"
      size="small"
      onClick={() => getUserManager()?.signoutRedirect().catch((error: unknown) => apm.captureError(error as Error))}
      sx={{ color: ColorPalette.WHITE, borderColor: ColorPalette.WHITE, mx: 1, whiteSpace: 'nowrap' }}
    >
      Log ud
    </Button>
  );
}
